import styled, { createGlobalStyle } from 'styled-components';

export const BiddingChatDrawerStyles = createGlobalStyle`
  :root {
    --bidding-chat-drawer-width: 46.2rem;
  }

  .modal.bidding-chat-drawer-modal {
    padding-left: 0;
    padding-right: 0;
    font-family: 'Roboto', sans-serif;
    pointer-events: none;
  }

  .modal.bidding-chat-drawer-modal.bidding-chat-drawer-modal--with-summary {
    z-index: 1060 !important;
  }

  .modal.bidding-chat-drawer-modal .modal-dialog.bidding-chat-drawer-dialog {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    left: auto;
    margin: 0;
    width: min(100vw, var(--bidding-chat-drawer-width));
    max-width: min(100vw, var(--bidding-chat-drawer-width));
    height: 100vh;
    max-height: 100vh;
    transform: translateX(100%);
    transition: transform 0.3s ease-out;
  }

  .modal-backdrop.bidding-chat-drawer-backdrop {
    opacity: 0.5;
  }

  .modal-backdrop.bidding-chat-drawer-backdrop--with-summary {
    opacity: 0.35;
    left: 0;
    right: auto;
    width: calc(
      100vw - min(100vw, var(--bidding-chat-drawer-width)) - min(
        var(--bidding-summary-drawer-width, 72rem),
        calc(100vw - min(100vw, var(--bidding-chat-drawer-width)))
      )
    );
  }

  .modal.bidding-chat-drawer-modal.show .modal-dialog.bidding-chat-drawer-dialog {
    transform: translateX(0);
  }

  .modal.bidding-chat-drawer-modal .bidding-chat-drawer-content {
    position: relative;
    height: 100vh;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: visible;
    pointer-events: auto;
  }

  .modal.bidding-chat-drawer-modal
    .bidding-chat-drawer-content
    > .bidding-chat-summary-fab-anchor {
    position: absolute;
    left: 0;
    top: 1.125rem;
    z-index: 1060;
    display: flex;
    transform: translateX(-100%);
    pointer-events: auto;
    line-height: 0;
  }

  .bidding-chat-summary-fab-anchor .bidding-chat-summary-fab-tooltip {
    font-family: 'Roboto', sans-serif;
    position: absolute;
    top: 50%;
    right: calc(100% + 0.4375rem);
    transform: translateY(-50%);
    padding: 0.5625rem 0.8125rem;
    border-radius: 6px;
    background-color: #1a2838;
    color: #fff;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgb(0 0 0 / 22%);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition:
      opacity 0.18s ease,
      visibility 0.18s ease;
  }

  .bidding-chat-summary-fab-anchor .bidding-chat-summary-fab-tooltip::after {
    content: '';
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    border-width: 6px 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent transparent #1a2838;
  }

  .bidding-chat-summary-fab-anchor:hover .bidding-chat-summary-fab-tooltip,
  .bidding-chat-summary-fab-anchor:focus-within .bidding-chat-summary-fab-tooltip {
    opacity: 1;
    visibility: visible;
  }

  .bidding-chat-summary-fab {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    padding: 0;
    border: none;
    border-radius: 9px 0 0 9px;
    box-shadow: 0 2px 8px rgb(0 0 0 / 18%);
    background: linear-gradient(90deg, #1e88e5 0%, #00897b 100%);
    color: #fff;
    cursor: pointer;
    transition: opacity 0.15s ease;
  }

  .bidding-chat-summary-fab:hover,
  .bidding-chat-summary-fab:focus {
    opacity: 0.95;
    outline: none;
    box-shadow: 0 2px 10px rgb(0 0 0 / 22%);
  }

  .bidding-chat-summary-fab img {
    width: 1.5rem;
    height: 1.5rem;
    display: block;
  }

  .modal.bidding-chat-drawer-modal--with-summary .bidding-chat-drawer-content {
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    box-shadow: none;
  }

  .bidding-chat-saved-drawer .bidding-chat-saved-question-inline-input.btn.btn-link {
    white-space: normal !important;
    word-break: break-word;
    cursor: text !important;
    border-radius: 0 !important;
    border: none !important;
    border-color: transparent !important;
    box-shadow: none !important;
    background-color: transparent !important;
    text-decoration: none;
    color: #1a2b3c !important;
  }

  .bidding-chat-saved-drawer .bidding-chat-saved-question-inline-input.btn.btn-link:hover,
  .bidding-chat-saved-drawer .bidding-chat-saved-question-inline-input.btn.btn-link:focus,
  .bidding-chat-saved-drawer .bidding-chat-saved-question-inline-input.btn.btn-link:active {
    outline: none !important;
    box-shadow: none !important;
    text-decoration: none;
    border-color: transparent !important;
    background-color: transparent !important;
    color: #1a2b3c !important;
  }

  .bidding-chat-saved-drawer .chatbot-input-group {
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background-color: transparent !important;
    min-height: 0 !important;
  }

  .modal.bidding-chat-drawer-modal .bidding-chat-container .chatbot .chatbot-form .chatbot-footer-meta {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    display: block;
    text-align: center;
  }
`;

export const Container = styled.div`
  &.bidding-chat-container {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
    font-family: 'Roboto', sans-serif;
    position: relative;
  }

  .bidding-chat-dismiss-saved-drawer-zone {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
  }

  .btn-feedback {
    font-size: 0.8rem;
    text-decoration: underline;
  }

  .modal-header.bidding-chat-drawer-header {
    background: ${(props) => props.theme.$white};
    border-bottom: 1px solid #e8e8e8;
    flex-shrink: 0;

    .modal-title {
      color: #1a2b3c;
      gap: 1rem;
    }

    .bidding-chat-header-text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }

    h5 {
      font-family: 'Roboto', sans-serif;
      font-weight: 600;
      font-size: 1.5rem;
      line-height: 100%;
      letter-spacing: 0;
    }

    small {
      color: #757575;
      font-family: 'Roboto', sans-serif;
      font-weight: 400;
      font-size: 1rem;
      line-height: 100%;
      letter-spacing: 0;
      margin-top: 0;
    }

    .btn-feedback {
      color: ${(props) => props.theme.$primary};
      white-space: normal;
    }

    .bidding-chat-header-toolbar {
      gap: 0.5rem;
    }

    .bidding-chat-header-toolbar > .btn.bidding-chat-panel-toggle {
      min-height: 40px;
      padding: 0.45rem 1.0125rem;
      border-radius: 7px;
      font-family: 'Roboto', sans-serif;
      font-size: 0.9rem;
      font-weight: 600;
      line-height: 1.2;
      white-space: nowrap;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }

    .bidding-chat-header-close {
      margin: 0;
      color: #9e9e9e;
      opacity: 1;
      text-shadow: none;
      padding: 0.35rem 0.25rem;
      font-size: 1.5rem;
      line-height: 1;
      font-weight: 300;

      &:hover,
      &:focus {
        color: #757575;
        opacity: 1;
      }
    }

    .bidding-chat-header-toolbar .btn-feedback {
      text-align: left;
    }
  }

  .bidding-chat-panel-toggle--saved-active {
    font-weight: 600;
    color: ${(props) => props.theme.$primary};
    border-color: ${(props) => props.theme.$primary};
    background: ${(props) => props.theme.$white};
  }

  .bidding-chat-panel-toggle--strategic-active {
    font-weight: 600;
    color: ${(props) => props.theme.$white};
    background: linear-gradient(90deg, #1e88e5 0%, #00897b 100%);
  }

  .bidding-chat-panel-toggle--strategic-active:hover,
  .bidding-chat-panel-toggle--strategic-active:focus {
    color: ${(props) => props.theme.$white};
    opacity: 0.95;
    text-decoration: none;
    box-shadow: none;
  }

  .bidding-chat-panel-toggle--strategic-active:disabled {
    opacity: 0.62;
    cursor: not-allowed;
  }

  .bidding-chat-panel-toggle--strategic-drawer-open {
    box-shadow: inset 0 0 0 2px rgb(255 255 255 / 25%);
  }

  .bidding-chat-strategic-content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  .bidding-chat-strategic-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: ${(props) => props.theme.$gray600} ${(props) => props.theme.$white};
  }

  .bidding-chat-strategic-accordion-item {
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    background: ${(props) => props.theme.$white};
    overflow: hidden;
  }

  .bidding-chat-strategic-accordion-head {
    border-radius: 0 !important;
    margin: 0 !important;
    padding: 0.65rem 0.85rem !important;
    border: none;
    background: #f5f6f8;
    font-family: 'Roboto', sans-serif;
    font-size: 0.9375rem;
    font-weight: 500;
    color: #1a2b3c;

    &:hover,
    &:focus {
      outline: none;
      background: #ebecef;
      text-decoration: none;
    }
  }

  .bidding-chat-strategic-accordion-title {
    padding-right: 0.75rem;
  }

  .bidding-chat-strategic-accordion-icon {
    flex-shrink: 0;
    font-size: 1.35rem;
    color: #757575;
  }

  .bidding-chat-strategic-accordion-collapse {
    display: grid;
    grid-template-rows: 0fr;
    overflow: hidden;
    background: ${(props) => props.theme.$white};
    transition: grid-template-rows 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .bidding-chat-strategic-accordion-collapse.is-open {
    grid-template-rows: 1fr;
  }

  .bidding-chat-strategic-accordion-collapse-inner {
    min-height: 0;
    overflow: hidden;
    border-top: 1px solid #e8e8e8;
    opacity: 0;
    transform: translateY(-6px);
    transition: opacity 0.28s cubic-bezier(0.4, 0, 0.2, 1),
      transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .bidding-chat-strategic-accordion-collapse.is-open
    .bidding-chat-strategic-accordion-collapse-inner {
    opacity: 1;
    transform: translateY(0);
  }

  @media (prefers-reduced-motion: reduce) {
    .bidding-chat-strategic-accordion-collapse,
    .bidding-chat-strategic-accordion-collapse-inner {
      transition: none !important;
    }

    .bidding-chat-strategic-accordion-collapse-inner {
      opacity: 1;
      transform: none;
    }
  }

  .bidding-chat-strategic-subgroup-heading {
    font-family: 'Roboto', sans-serif;
    font-size: 0.8125rem;
    font-weight: 600;
    color: #1a2b3c;
    letter-spacing: 0;
    margin: 1rem 0.85rem 0.35rem;
    padding: 0;
    line-height: 1.3;
  }

  .bidding-chat-strategic-question-btn {
    margin: 0;
    padding-left: 0.85rem;
    padding-right: 0.85rem;
    border: none;
    border-radius: 0 !important;
    background: transparent;
    font-family: 'Roboto', sans-serif;
    font-size: 0.9375rem;
    font-weight: 400;
    line-height: 1.4;
    color: ${(props) => props.theme.$primary};
    text-decoration: none;
    transition: background 0.15s ease;

    &:hover,
    &:focus {
      color: ${(props) => props.theme.$primary};
      background: ${(props) => props.theme.$primary_light};
      text-decoration: none;
      box-shadow: none;
    }

    &:focus {
      outline: none;
      z-index: 1;
      position: relative;
    }
  }

  .bidding-chat-saved-drawer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    width: 70%;
    max-width: 70%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: ${(props) => props.theme.$white};
    box-shadow: -6px 0 24px ${(props) => props.theme.$black}18;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    pointer-events: none;

    &.is-open {
      transform: translateX(0);
      pointer-events: auto;
    }
  }

  .bidding-chat-saved-drawer-header {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1rem 0.75rem;
    border-bottom: 1px solid #e8e8e8;
  }

  .bidding-chat-saved-drawer-title {
    font-family: 'Roboto', sans-serif;
    font-weight: 600;
    font-size: 1.125rem;
    color: #1a2b3c;
  }

  .bidding-chat-saved-drawer-close {
    border: none;
    padding: 0.25rem 0.35rem;
    margin: 0;
    background: transparent;
    color: #9e9e9e;
    font-size: 1.5rem;
    line-height: 1;
    cursor: pointer;

    &:hover,
    &:focus {
      color: #757575;
      outline: none;
    }
  }

  .bidding-chat-saved-questions-content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  .bidding-chat-saved-questions-list-outer {
    flex: 0 0 auto;
    min-height: 0;
    min-width: 0;
  }

  .bidding-chat-saved-questions-content--list-overflow .bidding-chat-saved-questions-list-outer {
    flex: 1 1 0%;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-color: ${(props) => props.theme.$gray600} ${(props) => props.theme.$white};
    scrollbar-width: thin;
  }

  .bidding-chat-saved-questions-loading-row {
    flex-shrink: 0;
  }

  .bidding-chat-saved-questions-footer {
    flex-shrink: 0;
  }

  .bidding-chat-saved-drawer .bidding-chat-saved-question-line {
    border-top: 1px solid #e8e8e8;
  }

  .bidding-chat-saved-drawer .bidding-chat-saved-question-line-actions {
    margin-left: -0.35rem;
  }

  .bidding-chat-saved-drawer .bidding-chat-saved-question-action-btn {
    color: ${(props) => props.theme.$primary};
    opacity: 1;
    padding-left: 0.1rem !important;
    padding-right: 0.1rem !important;

    &:hover,
    &:focus {
      color: ${(props) => props.theme.$primary};
      opacity: 0.88;
      text-decoration: none;
    }

    &:disabled {
      opacity: 0.45;
    }

    .material-icons-outlined {
      font-size: 1.525rem;
      line-height: 1;
      vertical-align: middle;
    }
  }

  .bidding-chat-saved-drawer .bidding-chat-saved-question-action-btn-spacer {
    padding-left: 0.1rem !important;
    padding-right: 0.1rem !important;

    .material-icons-outlined {
      font-size: 1.525rem;
      line-height: 1;
      vertical-align: middle;
    }
  }

  .bidding-chat-saved-drawer .bidding-chat-saved-new-question-wrap {
    border-top: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    padding: 0.35rem 0;
    margin: 0.375rem 0 0.75rem;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .bidding-chat-saved-drawer .bidding-chat-saved-question-list-edit-field {
    flex: 1 1 auto;
    min-width: 0;
    margin-left: 0.75rem;
    margin-right: 0.35rem;

    .bidding-chat-saved-new-question-inner.bidding-chat-saved-new-question-inner--list-edit {
      margin-left: 0;
      margin-right: 0;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      padding: 0 0.25rem;
      transition: border-color 0.15s ease;

      &.bidding-chat-saved-new-question-inner-row {
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    .bidding-chat-saved-question-inline-input.btn.btn-link {
      font-size: 1rem !important;
      line-height: 1.5 !important;
      padding: 0.125rem 0.35rem !important;
    }
  }

  .bidding-chat-saved-drawer .bidding-chat-saved-new-question-inner {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 0 0.35rem;
    margin-left: 1rem;
    margin-right: 1rem;
    width: calc(100% - 2rem);
    max-width: 100%;
    box-sizing: border-box;
    background: ${(props) => props.theme.$white};
    transition: border-color 0.15s ease;

    &:focus-within {
      border-color: ${(props) => props.theme.$gray400};
    }

    &.bidding-chat-saved-new-question-inner-row {
      min-height: 0;
      padding-top: 0.15rem;
      padding-bottom: 0.15rem;
    }
  }

  .bidding-chat-saved-drawer
    .bidding-chat-saved-new-question-wrap
    .bidding-chat-saved-question-inline-input.btn.btn-link {
    padding: 0.2rem 0.4rem !important;
    font-size: 0.9375rem;
    line-height: 1.35;
    min-height: 0;
  }

  .bidding-chat-saved-drawer .bidding-chat-saved-new-question-wrap .btn.btn-link.flex-shrink-0 {
    padding-bottom: 0 !important;
    padding-top: 0 !important;
  }

  .bidding-chat-saved-drawer .bidding-chat-saved-question-inline-input {
    max-height: 5rem;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: ${(props) => props.theme.$gray600} transparent;
    text-align: left;

    &:not(:empty)::before {
      content: '';
    }

    &.hide-content::before {
      content: '';
    }

    &[contentEditable='true']:focus {
      &::before {
        content: '';
      }
    }

    &[contentEditable='false'] {
      opacity: 0.5;
    }
  }

  .bidding-chat-saved-drawer
    .bidding-chat-saved-new-question-wrap--create
    .bidding-chat-saved-question-inline-input {
    &:empty::before,
    &:has(br:only-child)::before {
      content: 'Escreva sua pergunta';
      color: ${(props) => props.theme.$gray400};
    }
  }

  .chatbot {
    min-height: 0;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &-body {
      position: relative;
      flex: 1;
      min-height: 0;
    }

    &-line {
      height: 2px;
      background: ${(props) => props.theme.$manatee};
      margin-top: -2px;
    }

    &-messages {
      position: absolute;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      scrollbar-color: ${(props) => props.theme.$gray600} ${(props) => props.theme.$white};
      scrollbar-width: thin;

      .message-box .message-date {
        align-self: start;
      }
    }

    &-form {
      position: sticky;
      bottom: 0;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .chatbot-input-group {
        width: 100%;
        display: flex;
      }

      .btn-chatbot-send {
        background: ${(props) => props.theme.$info};
        color: ${(props) => props.theme.$white};
        border-radius: 0 4px 4px 0;
        &:disabled {
          cursor: default;
        }
      }

      .btn-chatbot-audio span,
      .chatbot-audio-cancel,
      .chatbot-audio-submit {
        background: transparent;
        color: ${(props) => props.theme.$gray600};
        border-radius: 0px;
        padding: 2px;
        &:disabled {
          cursor: default;
        }
        &:hover {
          background: ${(props) => props.theme.$gray300};
          padding: 2px;
          border-radius: 4px;
        }
      }
    }

    &-input {
      width: calc(100% - 40px);
      border-radius: 4px 0 0 4px;
      padding: 5px 15px;
      display: flex;
      align-items: center;
      overflow-y: scroll;
      overflow-x: hidden;
      word-break: break-word;
      outline: none;
      scrollbar-color: ${(props) => props.theme.$info} ${(props) => props.theme.$white};
      scrollbar-width: thin;

      &:empty::before,
      &:has(br:only-child)::before {
        content: 'Digite uma mensagem';
        color: ${(props) => props.theme.$gray400};
      }

      &:not(:empty)::before {
        content: '';
      }

      &[contentEditable='true']:focus {
        &::before {
          content: '';
        }
      }

      &-group {
        min-height: 51px;
        max-height: 85px;
        border: 1px solid ${(props) => props.theme.$gray400};
        border-radius: 4px;
      }

      &[contentEditable='false'] {
        opacity: 0.5;
      }
    }

    &-audio {
      &-control {
        display: flex;
        min-height: 52px;
      }
      &-recording {
        display: flex;
        align-items: center;
        padding-left: 15px;
        width: calc(100% - 40px);
      }
      &-equalizer-bars {
        display: flex;
        align-items: flex-end;
        gap: 3px;
        height: 20px;

        span {
          width: 3px;
          height: 6px;
          background: #6c757d;
          border-radius: 2px;
          animation: equalizer 1s infinite ease-in-out;
        }

        span:nth-child(1) {
          animation-delay: 0s;
        }
        span:nth-child(2) {
          animation-delay: 0.15s;
        }
        span:nth-child(3) {
          animation-delay: 0.3s;
        }

        @keyframes equalizer {
          0% {
            height: 6px;
            opacity: 0.4;
          }
          50% {
            height: 18px;
            opacity: 1;
          }
          100% {
            height: 6px;
            opacity: 0.4;
          }
        }
      }
    }

    &-footer-meta {
      margin-top: 0;
      padding-top: 0.25rem;
      padding-bottom: 0.5rem;
      font-size: 0.8rem;
      line-height: 1.25;

      &-inner {
        gap: 0.5rem 1rem;

        .chatbot-notice {
          flex: 0 1 auto;
          font-size: inherit;
          line-height: inherit;
          text-align: center;
          max-width: 100%;
        }

        .chatbot-footer-feedback {
          flex: 0 1 auto;
          max-width: 100%;
        }

        .chatbot-footer-feedback button.chatbot-footer-feedback-btn {
          -webkit-appearance: none;
          appearance: none;
          display: inline;
          vertical-align: baseline;
          margin: 0;
          padding: 0;
          border: none;
          background: transparent;
          cursor: pointer;
          font: inherit;
          white-space: normal;
          word-break: break-word;
          hyphens: auto;
          text-align: center;
          text-decoration: underline;
          color: ${(props) => props.theme.$primary};
          box-shadow: none;
        }

        .chatbot-footer-feedback button.chatbot-footer-feedback-btn:hover,
        .chatbot-footer-feedback button.chatbot-footer-feedback-btn:focus {
          color: ${(props) => props.theme.$primary};
          text-decoration: underline;
          outline: none;
        }
      }
    }

    &-notice {
      color: ${(props) => props.theme.$black}90;
      font-size: 0.8rem;
    }
  }

  .message {
    &-box {
      display: grid;
      grid-template-areas: 'author text date';
      grid-template-columns: minmax(80px, 80px) 1fr minmax(90px, 90px);

      @media only screen and (max-width: 768px) {
        grid-template-areas:
          'author date date'
          'text text text';
      }
    }

    &-text {
      word-break: break-word;
      grid-area: text;
    }

    &-date {
      grid-area: date;
    }

    &-author {
      grid-area: author;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      @media only screen and (max-width: 768px) {
        justify-content: flex-start;
      }

      .author-name {
        display: none;
      }
    }

    &-date,
    .chatbot-rating {
      font-size: 0.75rem;
    }

    &-loading {
      opacity: 0.5;

      &.chatbot-typing-indicator {
        display: inline-flex;
        align-items: baseline;
        gap: 0.28rem;
        opacity: 1;
        color: ${(props) => props.theme.$gray600};
        font-size: 0.875rem;
        line-height: 1;
      }
    }

    .chatbot-typing-dots {
      display: inline-flex;
      align-items: center;
      gap: 0.14rem;

      span {
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: ${(props) => props.theme.$gray600};
        opacity: 0.45;
        animation: bwChatTypingDot 1.05s ease-in-out infinite;
      }

      span:nth-child(2) {
        animation-delay: 0.14s;
      }

      span:nth-child(3) {
        animation-delay: 0.28s;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .chatbot-typing-dots span {
        animation: none;
        opacity: 0.55;
      }
    }

    .btn-rating {
      opacity: 0.3;
      color: ${(props) => props.theme.$black};

      &.rated {
        opacity: 1;
      }

      span {
        font-size: 1.25rem;
      }
    }
  }

  .user {
    background: ${(props) => props.theme.$white};
  }

  .assistant {
    background: ${(props) => props.theme.$gray200};
  }

  @keyframes bwChatTypingDot {
    0%,
    80%,
    100% {
      opacity: 0.4;
      transform: translateY(0);
    }
    40% {
      opacity: 1;
      transform: translateY(-2px);
    }
  }
`;
